import type { RawTilesetEntry } from "../tilesetConfigEntry";

export const environmentEntries: RawTilesetEntry[] = [
	{
		key: "Fire",
		animations: [
			{
				loop: true,
				tags: { attachedToThing: false },
				frames: [
					{ filename: "Fire_0.png", interval: 100 },
					{ filename: "Fire_1.png", interval: 100 },
					{ filename: "Fire_2.png", interval: 100 },
					{ filename: "Fire_3.png", interval: 100 },
				],
			},
			{
				loop: true,
				tags: { attachedToThing: true },
				offsetY: 0.6,
				frames: [
					{ filename: "Fire_0.png", interval: 100 },
					{ filename: "Fire_1.png", interval: 100 },
					{ filename: "Fire_2.png", interval: 100 },
					{ filename: "Fire_3.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "FireTower",
		animations: [
			{
				loop: true,
				height: 2,
				frames: [
					{ filename: "FireTower_0.png", interval: 100 },
					{ filename: "FireTower_1.png", interval: 100 },
					{ filename: "FireTower_2.png", interval: 100 },
				],
			},
		],
	},
	{
		key: "EmptyBarrel",
		sprite: "Barrel_Default.png",
	},
	{
		key: "ExplosiveBarrel",
		sprite: "Barrel_Warning.png",
	},
	{
		key: "GasBarrel",
		sprite: "Barrel_Warning_Green.png",
	},
	{
		key: "BloodPool",
		sprites: ["Blood_0.png", "Blood_1.png", "Blood_2.png"],
	},
	{
		// Two sprites + their mirrored versions (picked per-instance by visualId).
		key: "BilePuddle",
		animations: [
			{ frames: [{ filename: "BilePuddle_0.png", interval: 0 }] },
			{ frames: [{ filename: "BilePuddle_1.png", interval: 0 }] },
			{ horizontalFlip: true, frames: [{ filename: "BilePuddle_0.png", interval: 0 }] },
			{ horizontalFlip: true, frames: [{ filename: "BilePuddle_1.png", interval: 0 }] },
		],
	},
	{
		// Two sprites + their mirrored versions (picked per-instance by visualId).
		key: "ToxicSlugBrokenShell",
		animations: [
			{ frames: [{ filename: "RedSlugBrokenShell_1.png", interval: 0 }] },
			{ frames: [{ filename: "RedSlugBrokenShell_2.png", interval: 0 }] },
			{ horizontalFlip: true, frames: [{ filename: "RedSlugBrokenShell_1.png", interval: 0 }] },
			{ horizontalFlip: true, frames: [{ filename: "RedSlugBrokenShell_2.png", interval: 0 }] },
		],
	},
	{
		key: "LavaPool",
		animations: [
			{
				loop: true,
				tags: { top: true },
				frames: [
					{ filename: "Lava_top_0.png", interval: 400 },
					{ filename: "Lava_top_1.png", interval: 400 },
				],
			},
			{
				loop: true,
				tags: { normal: true },
				frames: [
					{ filename: "Lava_0.png", interval: 400 },
					{ filename: "Lava_1.png", interval: 400 },
				],
			},
		],
	},
	{
		key: "WaterTile",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "WaterTile_0.png", interval: 200 },
					{ filename: "WaterTile_1.png", interval: 200 },
				],
			},
		],
	},
	{
		key: "Chasm",
		animations: [
			{
				loop: true,
				tags: { top: true },
				frames: [{ filename: "Chasm_top.png", interval: 0 }],
			},
			{
				loop: true,
				tags: { normal: true },
				frames: [{ filename: "Chasm_0.png", interval: 0 }],
			},
		],
	},
	{
		key: "Landmine",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "MineOff.png", interval: 2000 },
					{ filename: "Mine.png", interval: 300 },
					{ filename: "MineOff.png", interval: 300 },
					{ filename: "Mine.png", interval: 300 },
				],
			},
		],
	},
	{
		key: "Gas",
		sprite: "Gas.png",
	},
	{
		// Four rotated variants of the same frames (picked per-instance by visualId)
		// break up the tiling effect across a gas cloud. See ConcreteBlock in terrain.ts.
		key: "BileGas",
		animations: [
			{
				loop: true,
				frames: [
					{ filename: "GasB_0.png", interval: 400 },
					{ filename: "GasB_1.png", interval: 400 },
				],
			},
			{
				loop: true,
				rotation: 1,
				frames: [
					{ filename: "GasB_0.png", interval: 400 },
					{ filename: "GasB_1.png", interval: 400 },
				],
			},
			{
				loop: true,
				rotation: 2,
				frames: [
					{ filename: "GasB_0.png", interval: 400 },
					{ filename: "GasB_1.png", interval: 400 },
				],
			},
			{
				loop: true,
				rotation: 3,
				frames: [
					{ filename: "GasB_0.png", interval: 400 },
					{ filename: "GasB_1.png", interval: 400 },
				],
			},
		],
	},
	{
		key: "Tomb",
		sprite: "Tomb.png",
	},
	{
		key: "Spreader",
		sprite: "Spreader.png",
	},
	{
		key: "BlackBox",
		sprite: "BlackBox.png",
	},
	{
		key: "Ashes",
		sprite: "Ashes.png",
	},
	{
		key: "GoldDrop",
		animations: [
			{ tags: { coins: 1 }, frames: [{ filename: "GoldCoin_1.png", interval: 0 }] },
			{ tags: { coins: 2 }, frames: [{ filename: "GoldCoin_2.png", interval: 0 }] },
			{ tags: { coins: 3 }, frames: [{ filename: "GoldCoin_3.png", interval: 0 }] },
			{ tags: { coins: 4 }, frames: [{ filename: "GoldCoin_4.png", interval: 0 }] },
			{ tags: { coins: 5 }, frames: [{ filename: "GoldCoin_5.png", interval: 0 }] },
			{ tags: { coins: 10 }, frames: [{ filename: "GoldCoin_10.png", interval: 0 }] },
			{ tags: { coins: 20 }, frames: [{ filename: "GoldCoin_20.png", interval: 0 }] },
			{ tags: { coins: 30 }, frames: [{ filename: "GoldCoin_30.png", interval: 0 }] },
			{ tags: { coins: 40 }, frames: [{ filename: "GoldCoin_40.png", interval: 0 }] },
			{ tags: { coins: 50 }, frames: [{ filename: "GoldCoin_50.png", interval: 0 }] },
		],
	},
];
